import React, { useState, useEffect, use } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import toast from 'react-hot-toast'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom'
import { useAuth } from './AuthContext'

const InstituteSelectionModal = ({ onClose, show }) => {
  const { token, roles, user_type } = useAuth()
  const navigate = useNavigate()
  const [selectInstitute, setSelectInstitute] = useState('') // Initialize as an empty string
  const [institutes, setInstitutes] = useState([]) // Initialize as an empty array to avoid map errors
  const [openModal, setOpenModal] = useState(false)
  // const handleClose = () => {
  //   navigate('/LoginSignup')
  //   setOpenModal(false)
  //   if (onClose) setOpenModal(false)
  // }

  useEffect(() => {
  console.log("Roles in authContext ->", roles);
  console.log("User_type in authContext ->", user_type);
}, [roles, user_type]);

  useEffect(() => {
    ApiEndpoints.getAllInstitutes()
      .then((res) => {
        setInstitutes(res.data.data) // Set the list of institutes
      })
      .catch((error) => {
        toast.error('Failed to fetch institutes.')
      })
  }, [])

  const handleSelect = (e) => {
    setSelectInstitute(e.target.value)
  }
  
const handleNonAdmin = async (institute_id) => {
  try {

    const response = await fetch(
      BASE_URL + `/user/role/${institute_id}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const result = await response.json();
    console.log("Non-admin role API result:", result);

    if (!response.ok) {
      toast.error(result.message || "Failed to load role details");
      return;
    }

    // Extract roles from API response
    const roles = result?.roles || [];

    // Store roles in cookie (optional)
    Cookies.set("user_roles", JSON.stringify(roles), { expires: 7 });

    if (roles.includes("accountant")) {
      toast.success("Welcome Accountant!");
      // navigate("/AssignClass");
      return;
    }

    // Handle teacher
    if (roles.includes("teacher")) {
      toast.success("Welcome Teacher!");
      // navigate("/AssignClass");
      return;
    }

    if(roles.includes("admin")){
     toast.success("Welcome Admin!")
    //  navigate("/Dashboard");
     return;
    }

    // Default case if no role matched
    toast.success("Welcome!");
    // navigate("/Dashboard");

  } catch (error) {
    console.error(error);
    toast.error("Error while fetching role details.");
  }
};

  const handleConfirm = async () => {
    console.log('institutes:', institutes) // ✅ Debugging log

    if (!selectInstitute) {
      toast.error('Please select an institute.')
      return
    }

    // Match using `institute_id` instead of `id`
    const institute = institutes.find(
      (inst) => inst?.institute_id?.toString() === selectInstitute?.toString(),
    )

    if (!institute) {
      toast.error('Invalid Institute Selection.')
      return
    }

    // Store in Cookies
    Cookies.set('institute_id', institute.institute_id, { expires: 7 })
    Cookies.set('institute_name', institute.name, { expires: 7 })

  //   const loginUserType = Cookies.get('user_type')
  //   const loginUserRole = Cookies.get('user_roles')
  //   console.log("Logged in user type:", loginUserType);
  //   console.log("Logged in user roles from cookie:", loginUserRole);
    
  //   if (loginUserType !== "admin") {
  //   console.log("Running NON-admin from LOGIN...");
  //   await handleNonAdmin(institute.institute_id);
  //   onClose();
  //   return;
  // }

    // 👉 For ADMIN use existing flow
    console.log("Running ADMIN existing flow...");
    
    navigate('/Dashboard')
    onClose()
  }

  return (
    <Modal show centered onHide={onClose}>
      <Modal.Header closeButton className="bg-info text-black">
        <Modal.Title>Select Institute</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Select Institute</Form.Label>
            <Form.Select onChange={handleSelect} value={selectInstitute}>
              <option value="">Select</option>
              {institutes.length > 0 ? (
                institutes.map((inst) => (
                  <option key={inst.institute_id} value={inst.institute_id}>
                    {inst.name}
                  </option>
                ))
              ) : (
                <option disabled>Loading...</option>
              )}
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="info" onClick={handleConfirm}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default InstituteSelectionModal
